import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('miniStatsCards')],1)],1),_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c(VSkeletonLoader,{attrs:{"type":"table","loading":_vm.loadingSaisons}},[_c('tableauClassement',{attrs:{"classement":_vm.classement}})],1)],1),_c(VCol,[_c(VSkeletonLoader,{attrs:{"type":"article","loading":_vm.loadingTimeline}},[_c('timeline',{attrs:{"timeline":_vm.timeline}})],1)],1)],1),_c(VRow)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }